import { render, staticRenderFns } from "./Idea.vue?vue&type=template&id=9f017676&"
import script from "./Idea.vue?vue&type=script&lang=js&"
export * from "./Idea.vue?vue&type=script&lang=js&"
import style0 from "./Idea.vue?vue&type=style&index=0&id=9f017676&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports